/*
 * @Description:
 * @Date: 2022-06-20 11:29:02
 */
import http from '@/utils/http/axios';
import { FaceRes } from './types';

enum Api {
  getToken = '/face/getToken',
  getResult = '/face/getResult',
  getUserNameByPhone = '/user/getUserNameByPhone', // 根据手机号获取用户姓名
  getRiskToken = '/face/risk/getToken',
  getRiskResult = '/face/risk/getResult'
}
export const getToken = async (params: {
  returnUrl: string;
  phone: string;
}) => {
  const resp = await http.request<Promise<Result<string>>>({
    url: Api.getToken,
    method: 'POST',
    params
  });
  return resp;
};

export const getResult = async (params: {
  bizId: string;
  phone: string | number;
}) => {
  const resp = await http.request<Promise<Result<FaceRes>>>({
    url: Api.getResult,
    method: 'POST',
    params
  });
  return resp;
};

export const getUserNameByPhone = async (params: {
  phone: string | number;
}) => {
  const resp = await http.request<Promise<Result<FaceRes>>>({
    url: Api.getUserNameByPhone,
    method: 'GET',
    params
  });
  return resp;
};

export const getRiskToken = async (params: {
  returnUrl: string;
  phone: string;
  extendInfo: string;
}) => {
  const resp = await http.request<Promise<Result<string>>>({
    url: Api.getRiskToken,
    method: 'POST',
    params
  });
  return resp;
};

export const getRiskResult = async (params: {
  bizId: string;
  phone: string | number;
}) => {
  const resp = await http.request<Promise<Result<FaceRes>>>({
    url: Api.getRiskResult,
    method: 'POST',
    params
  });
  return resp;
};
